exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Koafk_y5UxOQM{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:16px}._2Koafk_y5UxOQM button{width:136px;margin:0}._2Koafk_y5UxOQM button.RVPm69KXbG0oQ3{background:#8bbdd9}.UCmwumhY328ZT0{margin-bottom:8px}._2Vh1XUPiw1hY06{resize:none;height:80px}._3famzzTzQ26yGA{width:100%}", ""]);

// exports
exports.locals = {
	"useful": "_2Koafk_y5UxOQM",
	"selected": "RVPm69KXbG0oQ3",
	"question": "UCmwumhY328ZT0",
	"freeform": "_2Vh1XUPiw1hY06",
	"submit": "_3famzzTzQ26yGA"
};